export { default as BG_SPLIT_1 } from './bg1.png';
export { default as BG_SPLIT_2 } from './bg2.png';
export { default as BG_SPLIT_3 } from './bg3.png';
export { default as BG_SPLIT_4 } from './bg4.png';
export { default as BG_SPLIT_5 } from './bg7.jpg';
export { default as BG_SPLIT_6 } from './bg6.png';
export { default as BG_KASIA } from './kasia.png';
export const PRODUCT_TEMP = 'https://d1cbtwb0qnacuk.cloudfront.net/images/products/DefaultImage.png';
export { default as LoaderGif } from './LoadingGif.gif';
